export class CommunicationsLogList {
}
//# sourceMappingURL=communications-log-list.js.map